<template>
<b-modal id="deviceUpgradeModal" title="Upgrade LineSIGHT" size="lg" :no-close-on-backdrop="true" header-bg-variant="dark" header-text-variant="light" body-bg-variant="light"  :no-fade="true"
  @ok="sendUpgradeRequest">
  <b-container fluid>
    <h4 class="card-title">{{ product_serial_num }}</h4>
    <p class="card-text"><strong>Current Version: </strong><span v-if="device && device.software_version">{{device.software_version}}</span><span v-else>N/A</span></p>
    <br />
    <b-form inline>

    <label class="mr-sm-2" for="select-version-label"><strong>Select Target Version:</strong></label>
      <b-form-select class="mb-2 mr-sm-2 mb-sm-0"
        v-model="selectVersionsSelected"
        :options="versions"
        id="select-version"
        style="max-width: 100%;">
      </b-form-select>
    </b-form>
  </b-container>
</b-modal>
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex';

export default {
  name: "DeviceUpgradeModal",
  props: {
    device: {
      type: Object
    }
  },
  data() {
    return {
      selectVersionsSelected: '',
    };
  },
  methods: {
    ...mapActions('upgrades', [
        'findAllVersions', 'updatePackagesFromArtifactory', 'requestUpgradeDevices']),
    ...mapActions('alert', ['success', 'error']),
    refreshVersions() {
      return this.updatePackagesFromArtifactory().then(() => {
          this.findAllVersions().then( () =>  {
            if (this.versions.length > 0) {
              this.selectVersionsSelected = this.versions[0];
            }
          });
        })
    },
    sendUpgradeRequest() {
      const device_serial = this.device.product_serial_num;
      const upgrade_package_name = this.selectVersionsSelected;
      this.requestUpgradeDevices({ device: device_serial, versionSeleced: upgrade_package_name })
      .then(() => {
        this.success("Successfully scheduled device " + device_serial +
          " upgrade to version " + upgrade_package_name);
      })
      .catch(() => {
          this.error("Error sending upgrade request.");
      });
    }
  },
  computed: {
    ...mapGetters('upgrades', ['versions']),
    product_serial_num() {
      if (this.device) {
        return this.device.product_serial_num;
      }
      else {
        return '';
      }
    }

  },
  mounted() {
    this.findAllVersions().then(() => {
      this.refreshVersions();
    });
  }
};
</script>

<style src="./DeviceUpgradeModal.scss" lang="scss" scoped/>
